const config = {
  topMenu: true,
  rtl: false,
  darkMode: false,
  mainTemplate: 'lightMode',
};

export default config;
